// extracted by mini-css-extract-plugin
export default {"root":"d6f0Ga","bg":"udiga2","ribbon":"VElKvr","flRibbon":"CkYK5s","frRibbon":"n25I44"};